import type { ValueOf } from '@/types';

export const ALERT_TYPE = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
} as const;

export type AlertTypes = ValueOf<typeof ALERT_TYPE>;
